export type SystemCommandPayload = {
  type: 'message';
  text: string;
  command: true;
  sessionId: string | null;
  mode: string;
  agent: string;
};

export type SystemCommandContext = Omit<SystemCommandPayload, 'type' | 'text' | 'command'>;

// 统一构造工具栏系统指令消息，避免遗漏来源标记或会话上下文。
export function buildSystemCommandPayload(text: string, context: SystemCommandContext): SystemCommandPayload {
  return {
    type: 'message',
    text,
    command: true,
    ...context,
  };
}
